import { CompanyBrandingData } from '@customTypes/CompanyBranding';
import { DEFAULT_BRANDING } from '@pages/Settings/components/CompanyBranding/branding.constant';
import ColorPalletGenerator from '@utils/ColorPalletGenerator';

class BrandingManagerService {
  constructor() {}

  /**
   * Generate complete branding from base colors (frontend)
   */
  generateBrandingFromColors(
    branding: CompanyBrandingData | null,
  ): CompanyBrandingData {
    if (!branding) {
      return DEFAULT_BRANDING;
    }

    const { primary_color, secondary_color, accent_color, ...rest } = branding;

    const primaryPalette = ColorPalletGenerator.generatePalette(primary_color);
    const secondaryPalette =
      ColorPalletGenerator.generatePalette(secondary_color);
    const accentPalette = ColorPalletGenerator.generatePalette(accent_color);

    return {
      app_name: branding.app_name,
      primary_color: primary_color,
      secondary_color: secondary_color,
      accent_color: accent_color,
      primary_palette: primaryPalette,
      secondary_palette: secondaryPalette,
      accent_palette: accentPalette,
      additional_data: rest.additional_data,
      logo_url: branding.logo_url || '',
      font_family: branding.font_family || 'Manrope',
      theme_mode: branding.theme_mode || 'light',
    };
  }

  /**
   * Save branding to backend (only base colors + metadata)
   */
  async downloadBrandingCSS(
    companyName: string,
    brandingData: CompanyBrandingData,
  ) {
    try {
      const css = ColorPalletGenerator.generateCSSVariables(brandingData);
      const blob = new Blob([css], { type: 'text/css' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${companyName}-branding.css`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (error: any) {
      console.error('Download branding CSS error:', error);
      return {
        success: false,
        error: error.message || 'Failed to download branding CSS',
      };
    }
  }
}

export default new BrandingManagerService();
